import { NEXT_CONTACT_DATE_FIELDS, normalizeNextContactDate, persistedNextContactDate, saoPauloDateKey } from "./futureFollowUpGuard.mjs";
import { nextContactSaveChanges } from "./nextContactSave.mjs";

export function transferScheduleChanges(record, { module = "lead", now = new Date() } = {}) {
  const exempt = module === "prospect" && record.stage === "contatado";
  const field = module === "lead" ? "proxima_data_contato" : "followUp";
  const previous = Object.prototype.hasOwnProperty.call(record, field)
    ? normalizeNextContactDate(record[field]) : persistedNextContactDate(record);
  const today = saoPauloDateKey(now);
  const tomorrow = new Date(`${today}T12:00:00Z`);
  tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
  const date = exempt ? null : previous >= today ? previous : tomorrow.toISOString().slice(0, 10);
  return {
    ...nextContactSaveChanges(record, date, now.toISOString()),
    [field]:date,
    manualActionAt:now.toISOString(),
  };
}

export const TRANSFER_SCHEDULE_FIELDS = [...NEXT_CONTACT_DATE_FIELDS,
  "followUpUpdatedAt", "manualActionAt", "followUpCompleted", "followupCompleted",
  "nextContactCompleted", "followUpDoneAt", "followupDoneAt", "nextContactStatus"];

export function canTransferOwnedLead({ role, actorId, actorStoreId, ownerId, sourceStoreId }) {
  return ["admin", "superadmin"].includes(role)
    || (role === "manager" && Number(actorStoreId) === Number(sourceStoreId))
    || (role === "consultant" && Number(actorId) > 0 && Number(actorId) === Number(ownerId));
}

export function leadTransferDestinations(users, actor, lead) {
  if (!canTransferOwnedLead({ role:actor?.role, actorId:actor?.id, actorStoreId:actor?.storeId,
    ownerId:lead.consultantId ?? lead.assignedConsultantId ?? lead.consultorAtual,
    sourceStoreId:lead.storeId ?? lead.lojaAtual })) return [];
  return users.filter(user => user.role === "consultant" && user.storeId
    && Number(user.id) !== Number(lead.consultantId ?? lead.assignedConsultantId ?? lead.consultorAtual)
    && !user.disabled && user.active !== false && ![22, 31].includes(Number(user.id)));
}

export function transferBusinessPatch(record) {
  const patch = {...record};
  [...TRANSFER_SCHEDULE_FIELDS, "_transferReason", "_transferOnly"].forEach(field => delete patch[field]);
  return patch;
}

// Compact immutable transfer evidence only; never copy the conversation.
export function leadTransferSummary(record, names = {}, id = record?.lastOwnershipTransferId) {
  const event = record?.historicoTransferencias?.[id];
  if (!id || !event || !event.data) return null;
  const month = saoPauloDateKey(new Date(event.data)).slice(0, 7);
  if (!month) return null;
  return {id, month, leadName:event.leadName || record.nome || record.name || "Lead",
    fromStoreId:Number(event.lojaAnterior), toStoreId:Number(event.lojaDestino),
    fromConsultantId:event.de ?? null, toConsultantId:event.para,
    fromName:names[event.de] || (event.de == null ? "Aurora" : "Consultor"),
    toName:names[event.para] || "Consultor", reason:event.motivo || "",
    at:event.data, nextContactDate:event.nextContactDate ?? record.proxima_data_contato ?? record.followUp ?? null};
}
